import React from "react";
import { BackgroundImage } from "../Media";
import Heading from "./Heading";
import { IMediaItem } from "../../lib";

export interface IInfoBoxWithGridBladeProps {
    title?: string;
    titleHeadingLevel?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p";
    titleClassNames?: string;
    sectionClassNames?: string;
    sectionOverlayClassNames?: string;
    bgImageUrl?: string;
    boxClassNames?: string;
    infoGridClassNames?: string;
    infoArray?: { label: string; value?: string; valuePrefix?: string; icon?: Partial<IMediaItem> }[];
}

export const InfoBoxWithGridBlade: React.FC<IInfoBoxWithGridBladeProps> = ({
    title,
    titleHeadingLevel = "h2",
    titleClassNames = "",
    sectionClassNames = "",
    sectionOverlayClassNames = "",
    boxClassNames = "",
    infoGridClassNames = "",
    bgImageUrl,
    infoArray = [],
}) => {

    const childComponent = () => {

        const cellBorderClasses = "border-accent md:[&:nth-child(2n+1)]:border-r lg:[&:nth-child(2n+1)]:border-r-0 lg:[&:nth-child(3n+1)]:border-r lg:[&:nth-child(3n+3)]:border-l"
        const cellPaddingClasses = "pb-12 md:[&:nth-child(n+5)]:pb-0 lg:[&:nth-child(n+4)]:pb-0 px-12 lg:[&:nth-child(3n+1)]:pr-12 lg:[&:nth-child(3n+1)]:pl-6 lg:[&:nth-child(3n+3)]:pl-12 lg:[&:nth-child(3n+3)]:pr-6"

        return (
            <>
                {title && (
                    <Heading className={`px-2 mb-10 w-full mx-auto max-w-[1440px] text-inherit text-5xl ${titleClassNames}`} headingLevel={titleHeadingLevel}>{title}</Heading>
                )}
                <div className={`w-full px-2 bg-black/80 ${boxClassNames}`}>
                    <div className={`w-full mx-auto max-w-[1440px] py-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 ${infoGridClassNames}`}>
                        {infoArray.map((item, index) => (
                            <div key={index} className={`info-cell flex flex-col ${cellBorderClasses} ${cellPaddingClasses}`}>
                                {!item.icon?.url && item.value &&
                                    <div className="info-value text-center w-full flex justify-center items-center text-8xl xl:text-[9.375rem]">
                                        {item.valuePrefix && (
                                            <span className="info-prefix text-[2.75rem] xl:text-7xl">{item.valuePrefix}</span>
                                        )}
                                        {item.value}
                                    </div>
                                }
                                {item.icon?.url &&
                                    <div className="info-img-box h-[6rem] xl:h-[9.375rem] flex justify-center items-center">
                                        <img className="h-[4.15rem] w-[4.15rem] xl:h-[6.5rem] xl:w-[6.5rem] w-auto" src={item.icon.url} />
                                    </div>
                                }
                                <span className="info-label text-center">{item.label}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </>
        )
    }

    return (
        <>
            {bgImageUrl && (
                <BackgroundImage
                    className={`relative w-full text-composite-text ${sectionClassNames}`}
                    src={bgImageUrl}
                >
                    <div className={`pt-12 pb-16 ${sectionOverlayClassNames}`}>
                        {childComponent()}
                    </div>
                </BackgroundImage>
            )}
            {!bgImageUrl && (
                <section className={`relative w-full pt-12 pb-16 ${sectionClassNames}`}>
                    {childComponent()}
                </section>
            )}
        </>
    )
}

export default InfoBoxWithGridBlade